export default __webpack_public_path__ + "17e98b9e5586529b13ccb1f7af16861c.ttf";